<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-mute`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.931 13.001A2 2 0 004 15v18a2 2 0 002 2h7.37l9.483 6.639A2 2 0 0026 40v-6.93L5.931 13.001zM35.27 28.199l-3.311-3.313a7.985 7.985 0 00-1.96-6.107.525.525 0 01.011-.718l2.122-2.122a.485.485 0 01.7.008c3.125 3.393 3.938 8.15 2.439 12.252zM41.13 34.059l-2.936-2.937c3.07-5.89 2.226-13.288-2.531-18.348a.513.513 0 01.004-.713l2.122-2.122a.492.492 0 01.703.006c6.322 6.64 7.202 16.56 2.639 24.114zM26 18.928l-8.688-8.688 5.541-3.878A2 2 0 0126 8v10.928z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.012 4.184l35.272 35.272-2.828 2.828L4.184 7.012l2.828-2.828z"/></svg>
</template>
<script>

export default {
  name: 'IconFillMute',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
